import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT } from '@/graphql/fragments';

export const SEND_CHARTER_RECONFIRMATION_CODE = gql`
    ${ERRORS_FRAGMENT}
    mutation SendCharterReconfirmationCode($token: String!) {
        sendCharterReconfirmationCode(token: $token) {
            status
            message
            errors {
                ...ErrorType
            }
        }
    }
`;

export const CONFIRM_CHARTER_RETURN_DECISION = gql`
    ${ERRORS_FRAGMENT}
    mutation ConfirmCharterReturnDecision($token: String!, $code: String!, $passengers: [PassengerDecisionInput]!, $remarks: String) {
        confirmCharterReturn(token: $token, code: $code, passengers: $passengers, remarks: $remarks) {
            status
            message
            errors {
                ...ErrorType
            }
        }
    }
`;
